import TabsKind from "@/enums/tabs.enum";
import store from "..";
import FiltersUtils from "@/utils/FiltersUtils";

export default class DOMPlugin {
	initialize(): void {
		this.isMeVisibleCheck();
	}

	isMeVisibleCheck(): void {
		const meElementId = 'InlineSearchServicePlaceholder';
		const meElement = document.getElementById(meElementId);

		if (!meElement) return;

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				const isVisible = entry.isIntersecting;
				store.mutations.setAmIVisible(isVisible);

				if (!isVisible) return;

				const currentResultsCount = store.getters.getResults(TabsKind.PROGRAMMES)?.length;
				const hasAnyFilters = FiltersUtils.hasAnyFilters();

				if (currentResultsCount !== 0 || !hasAnyFilters) return;

				// void store.actions.updateProgrammesResults();
			});
		});

		observer.observe(meElement);
	}
}